import { Permission } from "./permission.model";

export class PermissionView {
	id: number;
	name: string;
	touched: boolean;
	permission: Permission;

	constructor(id:number,name:string){
		this.touched = false;
		this.id = id;
		this.name = name;
	}
}